import React from 'react'
import { InspirationUniverseContext } from 'app/React/InspirationUniverse/InspirationUniverseContainer'
import { useFirstRender } from 'app/React/InspirationUniverse/useFirstRender'
import useScroll from 'app/React/InspirationUniverse/useScroll'

export default function useProducts () {

  const firstRender = useFirstRender()
  const { scrollToContainer } = useScroll()

  const { restUrl, setProducts, currentPage, uuid, setTotalPages, setIsLoading, containerRef, setHasFetched } = React.useContext(InspirationUniverseContext)

  const fetchProducts = () => {
    if (!firstRender) {
      setIsLoading(true)
    }

    fetch(restUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        uuid: uuid,
        paged: currentPage
      })
    })
      .then((response) => response.json())
      .then((response) => {
        setProducts(response.posts)
        setTotalPages(response.totalPages)
      })
      .finally(() => {
        setIsLoading(false)
        setHasFetched(true)

        if (!firstRender) {
          scrollToContainer(containerRef)
        }
      })
  }

  return {
    fetchProducts
  }
}
